module.exports = __webpack_public_path__ + "assets/img/img6.9c849246.png";